<template>
    <div class="main-wrapper no-padding scroll-y custom-scrollbar view-academy-single infinite-list">

        <academy-segment></academy-segment>

        <div class="inner-padding">

            <div v-if="news" v-for="(item,index) in news" :key="item.slug">
                <item-news
                        :index="index+1"
                        :route="{ name: 'AcademyNewsSingle', params: { slug: $route.params.slug, id: item.slug }}"
                        :slug="item.slug"
                        :category="item.category"
                        :title="item.title"
                        :subtitle="item.excerpt"
                        :image="item.image"
                        :date="item.date_publication">
                </item-news>
            </div>

            <ion-button mode="ios" expand="block" class="mt-10 mb-10" @click="goTo('Academies')">
                <svg class="icon icon-chevron-back-white"><use xlink:href="#icon-chevron-back-white"></use></svg>
                <span style="display: inline-block; vertical-align: middle"><strong>Wyjdź z Akademii</strong></span>
            </ion-button>

        </div>
    </div>

</template>

<script>
    import api from '@/services/Api';
    import { mapState } from 'vuex';
    import goTo from '@/mixins/goto';
    import infiniteList from '@/mixins/infiniteList';

    import AcademySegment from '@/navs/AcademySegment';
    import ItemNews from '@/items/ItemNews';

    export default {
        name: 'AcademyNewsSingle',
        mixins: [goTo, infiniteList],
        components: { AcademySegment, ItemNews },
        computed: {
            ...mapState({
                loading: state => state.academies.loading,
                single: state => state.academies.single,
                news: state => state.academies.news,
            })
        },
        created(){
            this.$root.$on('intiniteList', (payload) => {
                this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE', false);
                this.getNews();
            });
        },
        beforeDestroy() {
            this.$root.$off("intiniteList");
        },
        mounted(){
            this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE', true).then(() => {
                this.getNews();
            });
        },
        methods: {
            getNews(){
                this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_NEWS_REQUEST', this.$route.params.slug)
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-item {
        --background: #f2f2f2;
    }
    ion-list {
        padding: 0;
    }
</style>